import { Icon, InputText } from "@bluframe/blublocks"
import Button from "components/buttons/Button"

import { ComponentProps } from "."
import MetadataFields from "./MetadataFields"
import {
  ArrowWrapper,
  Image,
  InputAndButton,
  Main,
  ServiceLabel,
  Wrapper
} from "./styled"

const Item = ({
  imageUrlRef,
  image,
  onArrowLeftClick,
  onArrowRightClick,
  onAlternativeTextInputChange,
  onCaptionInputChange,
  onCreditInputChange,
  onRegenerateAlternativeTextClick,
  onRegenerateCaptionClick,
  onImageUrlChange,
  onInputTextClick,
  onSelectImage,
  isAlternativeTextRegenerating,
  isCaptionRegenerating,
  showCreditInput,
  showScreenshotMetadataInputs
}: ComponentProps) => (
  <Wrapper $isSelected={image.isSelected} onClick={onSelectImage}>
    <ArrowWrapper>
      {onArrowLeftClick ? (
        <Button
          icon={<Icon name="IoArrowBack" />}
          iconOnly
          onClick={onArrowLeftClick}
          rounded
        />
      ) : null}
    </ArrowWrapper>

    <Main>
      {image.originalUrl ? (
        <Image alt={`${image.identifier} Image`} src={image.originalUrl} />
      ) : null}

      {image.originalUrl !== undefined && !image.id && !image.contentId ? (
        <InputAndButton>
          <InputText
            defaultValue={image.originalUrl}
            inputId={image.identifier}
            label="Image URL"
            name={`imageUrl-${image.identifier}`}
            onChange={onImageUrlChange}
            onClick={onInputTextClick}
            ref={imageUrlRef}
            type="text"
          />
        </InputAndButton>
      ) : (
        <ServiceLabel $isSelected={image.isSelected}>
          {image.filename}
        </ServiceLabel>
      )}

      {showCreditInput ? (
        <MetadataFields
          image={image}
          isAlternativeTextRegenerating={isAlternativeTextRegenerating}
          isCaptionRegenerating={isCaptionRegenerating}
          onAlternativeTextInputChange={onAlternativeTextInputChange}
          onCaptionInputChange={onCaptionInputChange}
          onCreditInputChange={onCreditInputChange}
          onInputTextClick={onInputTextClick}
          onRegenerateAlternativeTextClick={onRegenerateAlternativeTextClick}
          onRegenerateCaptionClick={onRegenerateCaptionClick}
          showScreenshotMetadataInputs={showScreenshotMetadataInputs}
        />
      ) : null}
    </Main>

    {onArrowRightClick ? (
      <ArrowWrapper>
        <Button
          icon={<Icon name="IoArrowForward" />}
          iconOnly
          onClick={onArrowRightClick}
          rounded
        />
      </ArrowWrapper>
    ) : null}
  </Wrapper>
)

export default Item
